import PropTypes from 'prop-types';
import React from 'react';
import { Dot, DotInner } from './Target.styled';

const Target = ({ handleDotClick, id, index, item, selected, smallScreen }) => {
  return (
    <Dot
      className="target"
      onClick={() => handleDotClick(index)}
      id={id}
      style={{
        left: smallScreen ? item.posX.small : item.posX.large,
        top: smallScreen ? item.posY.small : item.posY.large,
      }}
    >
      <DotInner className={selected ? 'is-selected' : ''}>
        {item.sidebar.title}
      </DotInner>
    </Dot>
  );
};

Target.propTypes = {
  handleDotClick: PropTypes.func,
  id: PropTypes.any,
  index: PropTypes.any,
  item: PropTypes.shape({
    posX: PropTypes.shape({
      large: PropTypes.any,
      small: PropTypes.any,
    }),
    posY: PropTypes.shape({
      large: PropTypes.any,
      small: PropTypes.any,
    }),
    sidebar: PropTypes.shape({
      title: PropTypes.any,
    }),
  }),
  selected: PropTypes.any,
  smallScreen: PropTypes.any,
};

export default Target;
